import { ConstantChampsFormulaires } from '../champs_formulaires/champs_formulaires/champs-formulaire.url';
import { Url } from '../../../shared/constant/url.constant';

/**
 * Route utilisées pour les fees & benefits.
 */
export namespace ConstantFormulaires {
  export const data = {
    title: 'Formulaires',
    sub: {
      lister: 'Lister',
      ajouter: 'Ajouter',
      ajout: {
        title: 'Ajout d\'un Formulaire'
      },
      liste: 'Liste',
      list: {
        title: 'Liste des Formulaire'
      }
    }

  }
  export const url = {
    FEES: {
      FEES_: 'formulaire',
      LIST: 'liste',
      ADD: 'add'
    }
  };

  export const urlFull = {
    FEES: {
      ADD: ConstantFormulaires.url.FEES.FEES_
        .concat(Url.SLASH_ROUTE).concat(ConstantFormulaires.url.FEES.ADD),
      LIST: ConstantFormulaires.url.FEES.FEES_
        .concat(Url.SLASH_ROUTE).concat(ConstantFormulaires.url.FEES.LIST),
    }
  };
}
